import React from "react";
import { Navigate, Route, Routes } from "react-router-dom"
import { publickRoutes, publickRoutNames } from 'router/index'
import AppRouterAdmin from "./AppRouterAdmin"
import AppRouterPrivate from "./AppRouterPrivate"
import AppRouterInfo from "./AppRouterInfo"
import PageWrapper from "./PageWrapper"
import styles from "./PageWrapper.module.scss";

const AppRouter = () => {
  return (
    // <Suspense fallback={<ContentLoader type="default" lines={5} />}>
    <Routes>
      <Route path="/" element={<Navigate to="/main/info" />} />
      <Route path="/logout" element={<Navigate to="/main/info" state={{ logout: true }} />} />
      <Route path="/enter" element={<Navigate to="/main/info" state={{ auth: true }} />} />
      <Route path="/private/*" element={<AppRouterPrivate />} />
      <Route path="/admin/*" element={<AppRouterAdmin />} />
      <Route path="/info/*" element={<AppRouterInfo />} />
      {publickRoutes.map((rout) => {
        const isMainInfoRoute = rout.path === `/${publickRoutNames.mainInfo}`;
        const element = isMainInfoRoute ? (
          <rout.component />
        ) : (
          <PageWrapper className={styles.mainPageWrapper}>
            <rout.component />
          </PageWrapper>
        );

        return (
          <Route path={rout.path} element={element} key={rout.path} />
        );
      })}
      <Route path="*" element={<Navigate to="/nofound" />} />
    </Routes>
    // </Suspense>
  )
}

export default AppRouter